import LocalizedStrings from "react-localization";

let String = new LocalizedStrings({
  ar: {
    shouldSelectquanity:'يجب إضافة كمية',
    notavailableProduct:'عفوا و هذا المنتج لم يعد متوفر',
    removefromcart:'تم إزالة المنتج بنجاح',
    notavailableSize:'عفوا , هذا المقاس لم يعد متوفر',
    addedtocart:'تم إضافة المنتج بنجاح ',
    shareproduct: "مشاركة المنتج من خلال",
    removefromFav: "تم ازالة المنتج من المفضلة",
    networkError: "خطاء بالاتصال بالانترنت",
    successRate: "تم تقيم المنتج بنجاح",
    addtoFav: "تم اضافة المنتج الي المفضلة",
    NoProducts: "لا يوجد منتجات",
    coins: "هل تريد فراطة عملة ؟",
    viscardOnDelivery: "  بطاقة إئتمانية عند الإستلام",
    visacard: "بطاقة الإئتمان",
    // Global
    addedvaluevalue: "قيمة الضريبة المضافة",
    moneyunit: "ريال",
    socialselect: "أو من خلال",
    cancelBTN: "الغاء",
    deleteBTN: "حذف",
    saveBTN: "حفظ",
    nextBTN: "التالي",
    confirmBTN: "تاكيد",
    Home: "الرئيسية",
    Categories: "الاقسام",
    productCategories: "اقسام المنتجات",
    lastOffers: " أحدث العروض",
    Aboutus: "من نحن",
    Contactus: "تواصل معانا",
    Contactusfooter: "اتصل بنا",
    Usage: "تعليمات الاستخدام",
    returnPolicy: "سياسة الاسترجاع",
    Privacy: "سياسة الخصوصية",
    DownloadApp: "حمل التطبيق الان",
    noproduct: "لا يوجد منتجات",
    applyBTN: "تطبيق",
    lowerprice: "من الاقل سعرا",
    higherprice: "من الاعلي سعرا",
    sendBTN: "إرسال",
    showall: "عرض الكل",
    lastproducts: "احدث المنتجات",
    all: "الكل",
    forget: "نسيت كلمه المرور ؟",
    newaccount: " تسجيل جديد",
    sendcode: "ادخل رقم الجوال الذى سجلت به من قبل ...لإرسال الكود عليه",
    mobilenum: "رقم الجوال",
    sententercode: "ادخل الكود المرسل على جوالك",
    resendcode: "إعادة إرسال الكود",
    enternewpassword: "ادخل كلمة المرور الجديدة",
    password: "كلمة المرور",
    confpassword: "تأكيد كلمة المرور",
    loading: "جاري التحميل ...",
    firstlogin: "يرجي تسجيل الدخول اولا",
    successsendreq: "تم إرسال الطلب بنجاح",
    interneterror: "خطاء بالاتصال بالانترنت",
    confirmpayment: "تأكيد الدفع",
    choosepaymentway: "أختر طريقه الدفع",
    creditcard: "بطاقه الإئتمان",
    cashdelivery: "نقدآ عند الأستلام",
    writenotes: "أكتب ملاحظاتك هنا...",
    free: "مجانا",
    deliverfee: "رسوم التوصيل",
    allbranches: "كل الفروع",
    successeditdata: "تم تعديل بياناتك بنجاح",

    // Header
    login: "تسجيل الدخول",
    searchproductname: "ابحث باسم المنتج ...",
    addorderimg: "أضف صورة الطلب",
    imgnotfoundinproducts: "في حالة عدم وجوده في المنتجات",
    muaccount: "حسابي",

    // Intro Filter
    selectgover: "المنطقة",
    selectcity: "المدينة",
    selectblock: "الحي",

    // Category
    arrange: "الترتيب",
    brand: "الماركة",

    // Profile
    editprofile: "تعديل الحساب",
    myorders: "طلباتي",
    addresslist: "قائمة العناوين",
    chat: "الدردشة",
    logout: "تسجيل الخروج",
    talkadmin: "تحدث مع المسؤول",
    writehere: "اكتب هنا....",
    nochat: "لا يوجد دردشة",
    changepassword: "تغير كلمة المرور",
    addnewaddress: "أضف عنوان جديد",
    addaddress: "أضف العنوان ",
    noaddress: "لا يوجد عناوين",
    mapaddress: "العنوان علي الخريطة",
    editaddress: "تعديل العنوان",
    deleteaddress: "هل تريد حذف هذا العنوان ?",
    addressdet: "العنوان بالتفصيل",
    additionalinfo: "بيانات أضافية عن العنوان",
    addressreq: "يجب ادخال العنوان بالتفاصيل *",
    street: "الشارع",
    streetreq: "يجب ادخال الشارع *",
    goverreq: "يجب اختيار المنطقة *",
    blockreq: "يجب اختيار الحي *",
    cityreq: "يجب اختيار المدينة *",
    searchplace: "ابحث عن المكان ...",

    // Header
    login: "تسجيل ",
    searchproductname: "ابحث باسم المنتج ...",
    addorderimg: "أضف صورة الطلب",
    imgnotfoundinproducts: "في حالة عدم وجوده في المنتجات",
    muaccount: "حسابي",
    // Favourite
    favourite: "المفضلة",
    nofavourite: "لا يوجد منتجات بالمفضلة",
    shopcart: "سلة المشتريات",
    nocartproduct: "سلة المشتريات فارغة",
    totalitems: "عدد الأصناف",
    items: "أصناف",
    item: "صنف",
    amount: "المبلغ",
    pound: "ريال",
    totalamount: " المبلغ الإجمالي ",
    totalamountBefore: "المبلغ",
    disvalue: "قيمة الخصم",
    disratio: "نسبة الخصم",
    thetotalamount: "المبلغ الإجمالي",
    addedvalueratio: "نسبة القيمة المضافة",
    addedvaluetax: "قيمة الضريبة المضافة",
    entercode: "ادخل كود الخصم",
    pleaseentercode: "من فضلك قم بادخال كود الخصم",
    activatecode: "تم تفعيل كود الخصم",
    errorconnect: "خطأ بالاتصال بالنت",
    excutereq: "ادفع الان",
    cantpay: "لا يمكنك الدفع",
    minpurchase: "يرجي الشراء بالحد الادني للمشتريات",
    minimumpurchase: "الحد الادني للشراء",
    availablequa: "الكمية المتاحة الان",
    ofthispro: "من هذا المنتج",

    // Notifications
    notifications: "الإشعارات",
    deletenoti: "هل تريد حذف هذا الاشعار؟",
    refusereq: "تم رفض طلبك",
    reason: "السبب",
    nonotifications: "لا يوجد إشعارات",
    copycode: "تم نسخ الكود بنجاح",

    checkcart: " مراجعة سلة المشتريات",
    confirmreq: "تأكيد وتنفيذ الطلب",
    successconfirmreq: "تم تأكيد طلبك بنجاح",
    unavailabelpayment: "غير متوفر الان الدفع بالبطاقة الإئتمانية",
    chooseaddress: "من فضلك اختر العنوان",
    addfav: "تم اضافة المنتج الي المفضلة",
    removefav: "تم ازالة المنتج من المفضلة",
    removefavourite: "هل تريد إزالة المنتج من المفضلة ؟",
    notavailable: "لا يتوفر حاليا",
    rateproduct: "تم تقييم المنتج بنجاح ",
    addcart: "تم اضافة المنتج الي عربة التسوق",
    addtocart: "اضف الي السلة",
    removecart: "تم ازالة المنتج من عربة التسوق",
    productdet: "تفاصيل المنتج",
    amount: "الكمية",
    productrate: "قيم هذا المنتج",
    from: "من",
    rates: "تقييمات",
    shareproduct: "مشاركة المنتج من خلال",
    similarProd: "منتجات متشابهة",
    notavailableprod: "لا يتوفر المنتج حاليآ",
    color: "اللون",
    size: "المقاس",

    // Orders
    hisfrom: "التاريخ من ...",
    histo: "التاريخ الي...",
    ordernum: "رقم الطلب",
    noorders: "لا يوجد طلبات",
    cancelreq: "هل تريد الغاء هذا الطلب?",
    cancelrequest: "الغاء الطلب",
    deleteorder: "تم مسح الطلب بنجاح",
    validend: "برجاء اختيار تاريخ نهاية صحيح",

    rights: "جميع الحقوق محفوظة",


  },
});

export default String;
